export function dismissLink() {
  return null
}

export type LinkExit = unknown
export type LinkSuccess = unknown
